<app-header/>

<div class="modal offerta" [class.modal-show]="isModalShow" [class.modal-hide]="!isModalShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <h4 class="text-center-modal">УГОДА КОРИСТУВАЧА (ВІДКРИТА ОФЕРТА)</h4>

  <p class="indent">
    Товариство з обмеженою відповідальністю «Маслоточка» (надалі – «Товариство») код ЄДРПОУ 44746445
    публікує даний Публічний договір (надалі – «Угода» та/або «Угода Користувача» та/або «Оферта»)
    про надання послуг на Інтернет-платформі Товариства за посиланням https://maslotochka.com положення якого викладені
    нижче по тексту.
    Угода користувача є публічною офертою та публічним договором. Згідно із положеннями ст.ст. 633, 641 Цивільного
    кодексу України
    умови публічної оферти та публічного договору є однаковими для всіх Користувачів. У відповідності до ч. 2 ст. 642
    Цивільного кодексу України,
    реєстрація на інтернет-платформі https://maslotochka.com є акцептом даної оферти, що прирівнюється до укладення
    договору на умовах викладених нижче по тексту,
    а також положення Політики конфіденційності. Політика конфіденційності регулює особливості обробки персональних
    даних Користувачів.
    Ознайомитися із положеннями Політики конфіденційності Товариства можна на сайті. Політика конфіденційності є
    невід’ємною частиною цих Умов.
  </p>

  <p class="indent">
    Дана публічна оферта адресована всім фізичним особам, фізічним особам-підприємцям та юридичним особам,
    що бажають скористатися послугою і мають технічну можливість одержання послуги.
    Сайт за посиланням https://maslotochka.com (надалі – «Сайт») надає послуги на умовах,
    викладених у даній Угоді.
  </p>

  <h4 class="text-center-modal">ТЕРМІНИ</h4>

  <p>
    <b>Сайт</b> – це платформа закритого типу для B2B користувачів в сфері автобзнесу,
    за якою закріплена унікальна IP адреса та розташована за посиланням: https://maslotochka.com,
    а також її похідні і піддомени, на яких розміщується інформація про Адміністратора;
    <br>
    <b>Адміністратор</b> – юридична та/або фізична особа-підприємець, яка за завданням Товариства здійснює технічне
    адміністрування Інтернет-платформи,
    забезпечує її функціонування на апаратному рівні та вирішує всі технічні питання, пов’язані з її працездатністю.
    Товариство може виступати Адміністратором Інтернет-платформи;
    <br>
    <b>Товариство</b> – ТОВ «Маслоточка», яка наділена виключними правами використання Інтернет-платфори на власний
    розсуд як самостійно,
    так і шляхом надання відповідних дозволів третім особам;
    <br>
    <b>Користувач</b> – будь-яка дієздатна особа, яка отримала зареєстрацію на Інтернет-платформі;
    <br>
    <b>Продавець</b> – Користувач Інтернет-платформи, який використовує його можливості з метою продажу Товару Покупцям
    за допомогою функціональних можливостей Інтернет-платформи; Товариство може теж виступати продавцем.
    <br>
    <b>Покупець</b> – Користувач Інтернет-платформи, який відвідує її з метою замовлення/придбання Товару у Продавця
    Товару;
    <br>
    <b>Акаунт</b> – індивідуальна сторінка Користувача з присвоєнням унікального ID номеру.
    В особистому кабінеті Користувач може вносити та редагувати особисту інформацію, яка відображається у нього на
    індивідуальній сторінці.
    В Акаунті Користувач може бачити свої замовлені товари. Доступ до Акаунту має виключно Користувач,
    який пройшов процедуру Реєстрації на Інтернет-платформі. Структуру і інтерфейс Акаунту визначає Адміністратор.
    Структура та інтерфейс Акаунту може змінюватися, але Адміністратор гарантує Користувачеві збереження раніше внесених
    ним даних;
    <br>
    <b>Реєстрація</b> – є акцепт Користувача даної Угоди і процедура, у процесі якої Користувач за допомогою заповнення
    відповідних форм Інтернет-платформи надає необхідну інформацію для використання сервісів та функціоналу
    Інтернет-платформи та отримує унікальний ID номер;
    <br>
    <b>Товар(и)</b> – пропозиція Продавця про продаж товару, яка за допомогою функціоналу Інтернет- платформи
    публікується на ньому.
  </p>

  <h4 class="text-center-modal">1. ЗАГАЛЬНІ ПОЛОЖЕННЯ</h4>

  <ul>
    <li>1.1. Ця Угода є публічним договором, і в разі прийняття (акцепту) викладених нижче умов будь-яка фізична особа,
      фізична особа-підприємець або юридична особа
      (надалі також – «Користувач») зобов’язується виконувати умови цієї Угоди.
    </li>
    <li>1.2. Угода може бути змінена Товариством без попереднього повідомлення та отримання додаткового погодження з
      боку Користувачів сайту.
    </li>
    <li>1.3. Актуальна версія Угоди, яка включає в себе всі чинні зміни, доступна за посиланням
      https://maslotochka.com
    </li>
    <li>1.4. Моментом укладання та набуття чинності цієї Угоди вважається момент Реєстрації Користувача на
      Інтернет-платформі
      за посиланням https://maslotochka.com та дія Угоди припиняється в разі блокування акаунту Користувача.
    </li>
    <li>1.5.Взаємодією з Інтернет-платформою є проходження реєстрації та відвідування Інтернет-платформи, використання
      будь-якого сервісу Інтернет-платформи,
      а також оформлення заказів Користувачами, останні підтверджують свою згоду з усіма умовами цієї Угоди без
      будь-яких виключень та застережень.
    </li>
    <li>1.6. Якщо Користувач не згоден з умовами Угоди повністю або частково, Адміністратор просить не використовувати
      функціонал
      Інтернет-платформи https://maslotochka.com
    </li>
    <li>1.7. У разі незгоди Користувача з будь-якими з положень цієї Угоди, Користувач не має права використовувати
      сервіси та функціонал Інтернет-платформи.
      Використання можливостей і сервісів Інтернет-платформи зареєстрованими Користувачами означає прийняття зобов’язань
      дотримуватись всіх правил і
      інструкцій користування послугами, а також цієї Угоди.
    </li>
    <li>1.8. Адміністратор пропонує Користувачеві послуги з використання Інтернет-платформи для придбання, продажу
      Товарів,
      а також використання додаткових можливостей, розроблених та запроваджених Товариством або Адміністратором.
    </li>
    <li>1.9. Сайт використовується Адміністратором на свій розсуд. З метою оптимізації та поліпшення
      роботи Інтернет-платформи,
      а також для поліпшення якості надаваних послуг, Адміністратор має право з власної ініціативи без додаткового
      повідомлення та/або узгодження
      з боку Користувачів додавати, змінювати, прибирати функціональні можливості Інтернет-платформи, інтерфейс
      Смарт-платформи, роботу Смарт-платформи,
      тематику Смарт-платформи, а також будь-яким іншим способом вносити зміни в структуру Інтернет-платформи.
    </li>
    <li>1.10. Адміністратор має право надавати на Інтернет-платформі послуги для необмеженої кількості Користувачів.
    </li>
    <li>1.11. Використовуючи сервіси Інтернет-платформи Користувач підтверджує, що йому зрозумілі його права, що він
      ознайомлений
      з Загальною політикою конфіденційності Товариства та Політикою щодо використання файлів cookies.
    </li>
  </ul>

  <h4 class="text-center-modal">2. УМОВИ КОРИСТУВАННЯ ІНТЕРНЕТ-ПЛАТФОРМОЮ</h4>

  <ul>
    <li>2.1. Використовуючи сервіси Інтернет-платформи, Користувач також погоджується з умовами надання всіх
      запроваджених
      в межах Інтернет-платформи додаткових послуг та программ, у тому числі користування телеграм-ботом
      @MaslotochkacomBot.
    </li>
    <li>2.2. Інформаційні повідомлення, призначені для широкого кола Користувачів, публікуються на Інтернет-платформі
      та/або розсилаються на електронні адреси у вигляді листів та/або у вигляді смс-повідомлень у телеграм-бот
      @MaslotochkacomBot
      тим Користувачам, які підтвердили свою згоду на отримання таких повідомлень в процесі придбання Товару/Реєстрації.
    </li>
    <li>2.3. Користувачі мають право відмовитися від отримання інформаційних повідомлень на свою електронну адресу
      в будь-який момент в налаштуваннях свого Акаунту.
    </li>
    <li>2.4. При виникненні між сторонами спорів та розбіжностей за цією Угодою або у зв'язку з нею сторони
      зобов'язуються
      вирішувати їх шляхом переговорів.
    </li>
    <li>2.5. Визнання судом недійсним будь-якого положення Угоди не тягне недійсності або невиконання інших положень
      цієї Угоди.
    </li>
    <li>2.6. Адміністратор та Товариство залишають за собою право одноосібного вибору платіжних інструментів
      та платіжних реквізитів для оплати Товарів Користувачами.
    </li>
    <li>2.7. Актуальність ціни на товари та будь-якої пов’язаної з цим інформації – зазначається на інтернет-платформі
      тільки в момент оновлення сторінки Користувача.
    </li>
    <li>2.8. Користуючись сервісами Інтернет-платформи, приймаючи умови даної Угоди, Користувач визнає
      і погоджується з усіма умовами здійснення розрахунків.
    </li>
    <li>2.9. Адміністратор та Товариство не несуть відповідальності за помилки, неточності, упущення, які були допущені
      при Реєстрації або розміщенні інформації, а також будь-які матеріальні або нематеріальні збитки, що виникли в
      зв'язку з цим.
    </li>
    <li>2.10. Адміністратор сумлінно виконує свої зобов'язання перед Користувачами, зокрема:</li>
    <li>- своєчасно, але не пізніше ніж протягом 3 робочих днів обробляє відповідні звернення Користувачів
      щодо некоректної роботи старт-платформи;
    </li>
    <li>- своєчасно розглядає, але не пізніше ніж протягом 5-ти робочих днів, і дає мотивовану відповідь на запити,
      що надходять від Користувачів, скарги, претензії і пропозиції, пов'язані з діяльністю Користувачів на
      Інтернет-платформі
      у тому ж вигляді,у якому вони надійшли (якщо усна скарга-то усна відповідь і т д)
    </li>
    <li>2.11. Приймаючи умови даної Угоди, Користувачі розуміють та повністю погоджуються з тим, що:</li>
    <li>2.11.1.Товариство та Адміністратор не гарантують відсутності помилок і збоїв, в тому числі щодо роботи
      програмного забезпечення.
      Адміністратор докладе всіх зусиль для усунення будь-яких збоїв і помилок в разі їх виникнення, в максимально
      короткі терміни;
    </li>
    <li>2.11.2. Товариство та Адміністратор не гарантують, що послуги та/або Товари будуть відповідати вимогам
      Користувача і надаватися безперервно і безпомилково;
    </li>
    <li>2.11.3. Адміністратор не гарантує, що якість Товарів і послуг, придбаних за допомогою Інтернет-платформи,
      буде відповідати очікуванням і/або вимогам Користувача, проте повністю гарантує оригінальну якість продукту.
    </li>
    <li>2.12. Користувачу забороняється втручатися в процеси функціонування Інтернет-платформи та її
      програмно-інформаційного забезпечення.
    </li>
    <li>2.13. Користувач зобов'язується не використовувати самостійно або із залученням третіх осіб можливості
      Інтернет-платформи з метою, що може бути кваліфікована як порушення прав третіх осіб на об’єкти інтелектуальної
      власності,
      недобросовісна конкуренція, інше порушення діючого законодавства України.
    </li>
  </ul>

  <h4 class="text-center-modal">3. РЕЄСТРАЦІЯ</h4>

  <ul>
    <li>3.1.Реєстраця на Інтернет-платформі можлива лише для B2B Користувачів в сфері автобізнесу, які мають повну
      правоздатність.
    </li>
    <li>3.2. Для здійснення Реєстрації на Інтернет-платформі Користувачу необхідно заповнити відповідні форми, що
      пропонуються,
      зокрема зазначити електронну адресу, номер телефону та вигадати пароль.
    </li>
    <li>3.3. Після проходження процедури Реєстрації Адміністратор активує Користувачу його Акаунт.</li>
    <li>3.4. Вхід до Акаунту здійснюється шляхом введення логіну і паролю.</li>
    <li>3.5. В Акаунті містяться данні про Користувача, які були введені ним при Реєстрації на Інтернет-платформі,
      відомості, внесені Користувачем
      через Акаунт в подальшому, а також інформація про історію усіх покупок, що здійснювались Користувачем за допомогою
      Інтернет-платформи.
    </li>
    <li>3.6. Реєстрація на Інтернет-платформі та створення Акаунту здійснюється безкоштовно.</li>
    <li>3.7. При Реєстрації на Інтернет-платформі Користувач зобов’язаний надати правдиву, точну і повну
      інформацію про себе в розділі Меню «Налаштування акаунту» і підтримувати цю інформацію в актуальному стані.
    </li>
    <li>3.8.У разі отримання недостовірної інформації Адміністратор має право призупинити або скасувати
      Реєстрацію Користувача і припинити надання послуг.
    </li>
    <li>3.9. Після проходження Користувачем процедури Реєстрації на Інтернет-платформі Адміністратор виходить з того,
      що інформація, вказана Користувачем при Реєстрації, є повною, точною та достовірною, а Користувач, як особа
      володіє усією
      повнотою правомочностей, необхідних для використання Інтернет-платформи та придбання Товарів.
    </li>
    <li>3.10. Користувач не повинен передавати свої дані доступу, зокрема логін та пароль до Акаунту третім особам. У
      випадку,
      якщо сторонні особи мають право доступу до Акаунту Користувача, або якщо існують інші ознаки зловживання акаунтом,
      Користувач повинен негайно повідомити Адміністратора про такі ознаки та змінити дані доступу.
      При цьому Адміністратор не несе відповідальності за дії сторонніх осіб.
    </li>
    <li>3.11. Користувач зобов'язується не використовувати самостійно або із залученням третіх осіб можливості
      Інтернет-платформи з метою
      порушення прав третіх осіб на об'єкти інтелектуальної власності, з метою недобросовісної конкуренції, з метою
      порушення законодавства
      країни знаходження Користувача або країни осіб, яким було завдано збитків або шкоди.
    </li>
  </ul>

  <h4 class="text-center-modal">4. ТОВАР ТА ЦІНОУТВОРЕННЯ</h4>

  <ul>
    <li>4.1. Продавець надає всю необхідну актуальну інформацію щодо Товарів в Акаунті Користувача.</li>
    <li>4.2. Актуальність ціни діє тільки на момент проведення фактичного розрахунку з Продавцем.</li>
    <li>4.3. Всі розрахунки за Товари та/або послуги, що надаються в межах Інтернет-платформи здійснюються в
      національній валюті – гривні.
      Вартість послуг може бути вказана в інших валютах в рекламних цілях для зручності Користувачів та є еквівалентом
      вартості послуги,
      що надається в національній валюті у відповідності до ст. 524 Цивільного кодексу України.
    </li>
    <li>4.4.Вартість послуг, що надаються, може змінюватись без додаткового попереднього повідомлення Користувачів.</li>
    <li>4.5.Товар, якого не має в наявності, Користувач може додати у список побажань у своєму Акаунті, вказуючи свою
      потребу на три місяці.
      З цього не виникає зобов’язання щодо купівлі вказаного продукту, проте дає змогу Товариству/Адміністратору
      корегувати попит Користувачів.
      Коли обраний товар з’явиться у наявності, Користувач отримує відповідне повідомлення у своєму Акаунті або у
      телеграм боті.
    </li>
    <li>4.6. Весь Товар, розміщений на Інтернет-платформі тільки оригінальної якості.</li>
  </ul>

  <h4 class="text-center-modal">5. ПРАВА ТА ОБОВ'ЯЗКИ</h4>
  <ul>
    <li>5.1. Адміністратор Інтернет-платформи має право:</li>
    <li>5.1.1. отримувати від Користувача інформацію, необхідну для функціонального використання Інтернет-платформи;
    </li>
    <li>5.1.2. розміщувати, змінювати, зберігати і видаляти будь-яку інформацію на інтернет-платформі;</li>
    <li>5.1.3. Розміщувати асортимент Товарів та/або послуг на Інтернет-платформі,самостійно вести цінову політику;</li>
    <li>5.1.4. Без отримання додаткових погоджень з боку Користувача скасувати Реєстрацію Користувача та припинити
      надання послуг Користувачу
      на Інтернет-платформі у разі, якщо Користувач своїми діями завдає шкоду Інтернет-платформі, діловій репутації
      Товариству/Адміністратору.
    </li>
    <li>5.1.5 Самостійно Розформовувати (оформлювати повернення) неоплачені або незабрані Товари Користувачів.</li>
    <li>5.2. Адміністратор Інтернет-платформи зобов'язується:</li>
    <li>5.2.1. Надавати Користувачу доступ до Інтернет-платформи відповідно до цієї Угоди.</li>
    <li>5.2.2. Інформувати Користувача про правила та вимоги використання Інтернет-платформи шляхом публікації
      відповідної інформації на Інтернет-платформі.
    </li>
    <li>5.2.3.Виконати зобов’язання щодо доставки оформлених та сплачених Користувачем Товарів/замовлень шляхом, обраним
      Користувачем
      на Інтернет-платформі в своєму Акаунті.
    </li>
    <li>5.3. Користувач має право:</li>
    <li>5.3.1. Отримати доступ до Інтернет-платформи відповідно до умов цієї Угоди.</li>
    <li>5.3.2. Отримувати додаткову інформацію з питань роботи Інтернет-платформи.</li>
    <li>5.3.3. Здійснювати покупку та продаж Товарів від свого імені за допомогою функціональних можливостей
      Інтернет-платформи.
    </li>
    <li>5.3.4. Поповнювати та мати свій баланс на Інтернет-платформі.</li>
    <li>5.3.5. Робити повернення замовлень у 14-денний термін, який передбачено діючим законодавством України.</li>
    <li>5.4. Користувачі зобов'язуються:</li>
    <li>5.4.1. В разі повернення Товару, дотримуватись вимог ЗУ «Про захист прав споживачів» та робити всі повернення
      через Інтернет-платформу.
    </li>
    <li>5.4.2. Надавати правдиву, точну та повну інформацію про себе у відповідних формах при Реєстрації на
      Інтернет-платформі.
    </li>
    <li>5.4.3. Ознайомлюватися з усією інформацію, що буде надходити від Товариства/Адміністратора шляхом повідомлення в
      Акаунті
      або у телеграм-боті щодо умов роботи з Інтернет-платформою.
    </li>
    <li>5.4.4.Сумлінно використовувати інформацію, отриману на Інтернет-платформі.</li>
  </ul>

  <h4 class="text-center-modal">6. ВІДПОВІДАЛЬНІСТЬ СТОРІН</h4>

  <ul>
    <li>6.1. За невиконання або неналежне виконання зобов'язань за цією Угодою сторони несуть відповідальність
      відповідно до чинного законодавства України.
    </li>
  </ul>

  <h4 class="text-center-modal">7. ЗБІР, ОБРОБКА, ЗБЕРІГАННЯ ПЕРСОНАЛЬНИХ ДАНИХ</h4>

  <ul>
    <li>7.1. Використовуючи сервіси Інтернет-платформи, Користувач також дає згоду на збирання та обробку персональних
      даних.
    </li>
    <li>7.2. Метою збору, зберігання та оброблення персональних даних є попередження можливих шахрайських дій щодо
      Користувачів,
      а також надання Користувачам персоналізованих сервісів Інтернет-платформи, в тому числі, але не обмежуючись:
      доступ до Акаунту,
      авторизація, скидання паролю, публікація та надсилання оголошень та/або іншої інформації.,
    </li>
    <li>7.3. Адміністратор, окрім основних персональних даних (прізвище, ім’я, по батькові, адреса, номер засобу
      зв’язку,
      електронна поштова адреса), також має право збирати, обробляти, зберігати додаткові (технічні) дані Користувача
      (файли cookies,
      інформацію про з’єднання, системну інформацію та ін.).
    </li>
    <li>7.4. Обробка персональних даних включає в себе будь-які дії та/або сукупність дій, пов’язаних зі збором,
      реєстрацією,
      накопиченням, зберіганням, адаптацією, зміною, оновленням, використанням та розповсюдженням (реалізацією,
      переданням),
      видаленням персональних даних Користувача з метою забезпечення роботи необхідних сервісів Інтернет-платформи.
    </li>
    <li>7.5. Користувач надає згоду Адміністратору на використання файлів cookies задля забезпечення інформування,
      оптимізації та відображення оголошень на підставі попередніх відвідувань Інтернет-платформи.
    </li>
    <li>7.6. Адміністратор використовує загальноприйняті стандарти технологічного та операційного захисту інформації
      та персональних даних від втрати, неправильного використання, зміни або знищення. Однак, не дивлячись на всі
      зусилля,
      Адміністратор не може гарантувати абсолютну захищеність від будь-яких загроз, що виникають поза межами регулювання
      Адміністратора.
    </li>
    <li>7.7. Адміністратор забезпечує застосування всіх відповідних зобов’язань щодо дотримання конфіденційності,
      а також технічних і організаційних заходів безпеки для запобігання несанкціонованого або незаконного розголошення
      або обробки такої інформації та даних, їх випадкової втрати, знищення або пошкодження.
    </li>
    <li>7.8. Користувач погоджується з тим, що конфіденційність переданих через Інтернет даних не гарантована і у разі,
      якщо доступ до цих даних буде отриманий третіми особами поза межами технічних засобів зв’язку, використовуваних
      Адміністратором,
      Адміністратор не несе відповідальності за шкоду, заподіяну таким доступом.
    </li>
    <li>7.9.Детально ознайомитись з інформацією щодо даних, які збираються Адміністратором про Користувачів, як зібрані
      дані обробляються
      та зберігаються, можна в Загальній політиці конфіденційності, що розміщена на Інтернет-платформі.
    </li>
  </ul>

  <h4 class="text-center-modal">8. АВТОРСЬКЕ ПРАВО</h4>

  <ul>
    <li>8.1. Усі матеріали, що розміщені на Інтернет-платформі, а саме: код HTML, сценарії, текст, графіка, логотипи,
      значки кнопок, зображення,
      відео, програмне забезпечення, мобільні додатки і аудіо є власністю Товариства або власністю контрагентів
      Товариства і захищаються законодавством.
    </li>
    <li>8.2. Усе програмне забезпечення, що використовується на Інтернет-платформі, є власністю Товариства або власністю
      контрагентів Товариства і захищається законодавством України та міжнародним законодавством про авторське право.
    </li>
  </ul>

  <h4 class="text-center-modal">9. СПОРИ</h4>

  <ul>
    <li>9.1. Будь-яка претензія, необхідна для подання до суду, передається шляхом подачі позову протягом
      3 (трьох) місяців з моменту виникнення події, що стала підставою для подачі претензії.
    </li>
    <li>9.2. Права і обов’язки сторін щодо вирішення спорів в суді повинні реалізовуватися згідно норм чинного
      законодавства відповідної країни реєстрації.
    </li>
    <li>9.3. Судові рішення і постанови, які набрали законної сили, є остаточними і обов'язковими для виконання.</li>
    <li>9.4. Суд не має повноважень вносити поправки або зміни в дану Угоду.</li>
  </ul>

  <h4 class="text-center-modal">10. ІНШІ УМОВИ</h4>

  <ul>
    <li>10.1. Товариство та Адміністратор не несуть відповідальності за шкоду або збитки, яких зазнав Користувач або
      треті особи в результаті помилкового розуміння або нерозуміння умов даної Угоди, інструкцій або вказівок про
      порядок
      використання Інтернет-платформи, щодо порядку розміщення даних та інших технічних питань. До моменту прийняття
      умов
      даної Угоди будь-який Учасник має право звернутися до Адміністратора для отримання роз’яснень щодо положень Угоди.
    </li>
  </ul>
</div>

<div class="dark-layer" [class.modal-show]="isDarkBackground" (click)="closeModal()"></div>

<div class="row header-text">
  <div class="column"><h3 class="text-center">Актуалізуйте ваші дані</h3></div>
</div>

<div>
  <div class="row" [class.border-wrong]="wrongFio">
    <div class="column">
      <label>ПІБ або назва організації</label>
      <input
        #scrollInputRef
        [(ngModel)]="fio"
        (input)="validationFio()"
        type="text"
        name="fio"
        class="expanded"
        placeholder="ПІБ або назва організації">
      <span class="status" [class.status-error]="wrongFio">{{ errorMessageFio }}</span>
    </div>
  </div>

  <div class="row" [class.border-wrong]="wrongPhone">
    <div class="column">
      <label>Телефон</label>
      <input
        #scrollInputRef
        class="expanded masked-phone"
        #phoneRef
        [(ngModel)]="phone"
        (input)="validationPhone()"
        type="tel"
        name="phone"
        placeholder="Телефон"
        autocomplete="phone"
        appPhoneMask
      >
      <span class="status" [class.status-error]="wrongPhone">{{ errorMessagePhone }}</span>
    </div>
  </div>

  <div class="additional-phones" *ngFor="let addPhone of additionPhones; let i = index">
    <div class="row" [class.border-wrong]="addPhone.error">
      <div class="column">
        <label>Додатковий телефон</label>
        <a class="close-phone" (click)="closePhone(i)"></a>
        <input
          class="expanded masked-phone"
          [(ngModel)]="addPhone.name"
          (input)="validationAdditionalPhone()"
          #phoneAdditionRef
          type="tel"
          name="additional-phones{{i}}"
          placeholder="Телефон"
          autocomplete="phone"
          appPhoneMask>
        <span class="status" [class.status-error]="addPhone.error">{{ addPhone.errorMessage }}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="column add-phone">
      <a class="alert" (click)="addPhone()">Вказати додатковий телефон</a>
    </div>
  </div>

  <div class="row">
    <div class="column">
      <label>Email(логін)</label>
      <input
        [(ngModel)]="email"
        type="text"
        name="email"
        class="expanded"
        placeholder="Email(логін)"
        disabled>
    </div>
  </div>

  <div class='row city-text' [class.border-wrong]="wrongCity">
    <div class='column city-field'>
      <label>Місто
        <span class="alert">(пропишіть і виберіть зі списку)</span>
      </label>
      <input [(ngModel)]="cityId" type="hidden" name="city_id">
      <input [(ngModel)]="areaId" type="hidden" name="area_id">
      <input
        #scrollInputRef
        type='text'
        name='city'
        (input)="searchCity()"
        [(ngModel)]="city"
        (change)="validationCity()"
        class='expanded'>
      <span class="status" [class.status-error]="wrongCity">{{ errorMessageCity }}</span>
      <ng-container *ngIf="addressData.length > 0">
        <div class="np-search-results">
          <ul>
            <li>
              <a *ngFor="let address of addressData; let i = index" (click)="getCity(i)">{{ address.description }}</a>
            </li>
          </ul>
        </div>
      </ng-container>
    </div>
  </div>

  <div class='row city-text additional-address' [class.border-wrong]="addCity.error"
       *ngFor="let addCity of additionalCity; let i = index">
    <div class='column city-field'>
      <label>
        Місто
      </label>
      <a class="close-address" (click)="closeAddress(i)"></a>
      <input
        [(ngModel)]="addCity.city_id"
        type="hidden"
        name="city_id{{i}}">
      <input
        [(ngModel)]="addCity.area_id"
        type="hidden"
        name="area_id{{i}}">
      <input
        type='text'
        name='city'
        (input)="searchAdditionalCity(i)"
        [(ngModel)]="addCity.city"
        (change)="validationAdditionalCity()"
        class='expanded'>
      <span class="status" [class.status-error]="addCity.error">{{ addCity.errorMessage }}</span>
      <ng-container *ngIf="additionalCityData.hasOwnProperty(i) && additionalCityData[i].length > 0">
        <div class="np-search-results">
          <ul>
            <li>
              <a *ngFor="let newAdditionalCity of additionalCityData[i]; let j = index"
                 (click)="getAdditionalCity(j, i)">{{ newAdditionalCity.description }}</a>
            </li>
          </ul>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="row address-text">
    <div class="column">
      <a class="alert address-text-line-height"
         *ngIf="counterAddress < 2"
         (click)="addArea()">Вказати додаткове місто</a>
    </div>
  </div>

  <div class="row" [class.border-wrong]="wrongSphere">
    <div class="column">
      <label>Сфера діяльності</label>
      <select [(ngModel)]="sphereId" (change)="wrongSphere = false" name="sphere_id" class="expanded">
        <option *ngFor="let sphere of spheres" value="{{sphere.id}}">{{ sphere.name }}</option>
      </select>
      <span class="status" [class.status-error]="wrongSphere">{{ errorMessageSphere }}</span>
    </div>
  </div>

  <div class="row" [class.border-wrong]="wrongAddress">
    <div class="column">
      <label>Фактична адреса</label>
      <input
        #scrollInputRef
        [(ngModel)]="address"
        (input)="validationAddress()"
        type="text"
        name="address"
        class="expanded"
        placeholder="Фактична адреса">
      <span class="status" [class.status-error]="wrongAddress">{{ errorMessageAddress }}</span>
    </div>
  </div>

  <div class="additional-spheres" *ngFor="let addSphere of additionalSpheres; let i = index">
    <div class="row">
      <div class="column">
        <label>Виберіть додаткову сферу діяльності</label>
        <a class="close-additional-spheres" (click)="closeAddressSpheres(i)"></a>
        <select
          [class.border-wrong]="addSphere.errorSphere"
          [(ngModel)]="addSphere.name"
          (change)="validationAdditionalSphere()"
          name="additional-spheres{{i}}"
          class="expanded">
          <option value="{{addSphere.id}}">Виберіть вашу сферу діяльності</option>
          <option *ngFor="let sphere of spheres" value="{{sphere.id}}">{{ sphere.name }}</option>
        </select>
        <span class="status" [class.status-error]="addSphere.errorSphere">{{ addSphere.errorMessageSphere }}</span>
      </div>
    </div>

    <div class="row" [class.border-wrong]="addSphere.error">
      <div class="column">
        <label>Додаткова адреса</label>
        <input
          [(ngModel)]="addSphere.address"
          type="text"
          name="address{{i}}"
          class="expanded">
        <span class="status" [class.status-error]="addSphere.error">{{ addSphere.errorMessage }}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="column">
      <a class="alert hide-for-small-line-height" (click)="addSphere()">Вказати додаткову сферу діяльності</a>
    </div>
  </div>

  <div class="row">
    <div class="column">
      <label class="label-checkbox label-checkbox-text" [class.label-checkbox-active]="isLabelCheckbox"
             (click)="passConditions()">
        Погоджуюсь з усіма умовами
      </label>
    </div>
  </div>

  <div class="row">
    <div class="column">
      <a (click)="openModal()" class="text-decoration">Угода користувача</a>
    </div>
  </div>

  <div class="row" *ngIf="isLabelCheckbox">
    <div class="column">
      <input type="hidden" name="post_sent" value="1">
      <button type="submit" class="button button-text" id="button_save" (click)="buttonSaveSurvey()">Зберегти</button>
    </div>
  </div>
</div>

<footer>
  <small>© 2010-2023 Maslotochka. Всі права захищені.</small>
</footer>
